import React from 'react'

import { useAuthorization } from '~/hooks/useAuthorization'
import { exists, setAuthorizedSrc } from '~/utils'

export type AuthorizationRequiredImageProps = JSX.IntrinsicElements['img']

export const AuthorizationRequiredImage = ({
  src,
  ...rest
}: AuthorizationRequiredImageProps) => {
  const getAuthorization = useAuthorization()
  const handleRef = React.useCallback<React.RefCallback<HTMLImageElement>>(
    (element) => {
      if (exists(element) && exists(src)) {
        setAuthorizedSrc({ element, getAuthorization, src })
      }
    },
    [getAuthorization, src],
  )

  return <img ref={handleRef} {...rest} />
}
